/**
 * Dispara o download de um blob no browser (app real; não há restrição de download aqui). Cria um link
 * temporário, clica nele e revoga o object URL. Usado pelas exportações (CSV etc.).
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}

/** Conveniência: monta um blob de texto (UTF-8) e dispara o download. */
export function downloadTextFile(content: string, filename: string, mimeType: string): void {
  downloadBlob(new Blob([content], { type: `${mimeType};charset=utf-8` }), filename)
}
